/* @flow */
import React from 'react'
import FaClose from 'react-icons/lib/fa/close'

import './style.css'
// import { hide360 } from '../../actions/global'

class Modal extends React.Component {
  // state = {
  //   opacity: new Animated.Value(0),
  //   scale: new Animated.Value(0),
  // }

  componentDidMount() {
  }

  render() {
    const { isShown, theaterMode, shouldCloseOnOverlayClick, close, children } = this.props
    if (isShown) {
      return (
        <div className="backdrop"
          onClick={shouldCloseOnOverlayClick ? close : null}>
          <div className={'modal' + (theaterMode ? ' theater' : '')}>
            <div className="close" onClick={close}>
              <FaClose size={24} color={theaterMode ? 'white' : '#656464'} />
            </div>
            {children}
          </div>
        </div>
      )
    } else {
      return null
    }
    
  }
}

export default Modal


// WEBPACK FOOTER //
// ./src/components/Modal/index.js